export const EAirportType = {
  "0": "UNKNOWN",
  "1": "AIRPORT",
  "2": "CITY",
  "-1": "ALL"
};

export const EAirportVerifyStatus = {
  "0": "UNKNOWN",
  "1": "NOT_PATTERNIZED",
  "2": "PATTERNIZED",
  "3": "VERIFIED",
  "-1": "ALL"
};